module.exports = __webpack_public_path__ + "img/whats-new-53-colordrop_9x16_poster.f92f9eb.jpg";